import { classNames } from 'primereact/utils';
import React from 'react';

const ContainerType = {
    CARD: 'card',
    DIALOG: 'dialog'
};

type FormContainerProps = {
    children: React.ReactNode;
    type?: 'card' | 'dialog';
};

export const FormContainer = ({ children, type }: FormContainerProps) => {
    return (
        <div
            className={classNames('form-container', {
                'form-container--card': type === ContainerType.CARD,
                'form-container--dialog': type === ContainerType.DIALOG
            })}
        >
            {children}
        </div>
    );
};
